/**
 * ГДЕ ПРОСИТЬ КОД ИЗ ПИСЬМА — вход через аккаунт Intch (MR !45). Решение Димы 2026-10-19: «рега должна
 * происходить на шаге контакт» — код сразу после почты, умолчание `contact` (до того умолчанием был
 * `workspace`, по его же решению 2026-10-01 «код там, где человеку уже есть что терять»).
 *
 * Одна настройка на сборку и на сервер: `VITE_AUTH_GATE` в .env репозитория. Сборка читает её как
 * переменную Vite, сервер — как обычную (server/src/config/env.ts `authGate`), поэтому замок на экране
 * и замок на поиске не расходятся.
 *   · `contact` (по умолчанию) — код сразу после почты, как сделано в MR !45: выдача, поиск и кабинет
 *     закрыты входом, прогон сразу пишется на человека (routes/search.ts runCreator).
 *   · `workspace` — код на входе в кабинет. Выдача и первый поиск анонимны, как до входа: прогон
 *     пишется на аккаунт браузера и переходит к человеку при первом входе (linkAccount, импорт по
 *     ключу прогона). «Спасибо» открыта в обоих режимах — заказ и тариф пишутся без входа
 *     (routes/pay.ts принимает возврат без пользователя).
 * Воронка 4 просит код на регистрации в обоих режимах: там регистрация — собственный шаг воронки.
 *
 * Lead во всех режимах уходит при вводе почты, как до входа: обе кампании в Мете учатся на нём, и
 * перенос за код поменял бы им событие оптимизации, а Lead перестал бы сравниваться с историей.
 */
export type AuthGate = 'workspace' | 'contact'

/** Всё, кроме точного `workspace`, — `contact`: опечатка в .env не должна открыть выдачу без входа. */
export const parseAuthGate = (raw: unknown): AuthGate => (String(raw ?? '').trim() === 'workspace' ? 'workspace' : 'contact')

export const AUTH_GATE: AuthGate = parseAuthGate(import.meta.env?.VITE_AUTH_GATE)

/** Выдача (мастер, шаг 6) закрыта входом только при коде сразу после почты. */
export const wizardNeedsSignIn = (gate: AuthGate = AUTH_GATE): boolean => gate === 'contact'

/**
 * Что делает отправленный контакт онбординга (воронки 1–3): прислать код или сразу отдать спеку
 * воронке. Вошедший (cookie с intch.org или прошлого визита) код не вводит ни в одном режиме.
 */
export const afterContact = (gate: AuthGate, signedIn: boolean): 'code' | 'funnel' =>
  gate === 'contact' && !signedIn ? 'code' : 'funnel'

/** Регистрация воронки 4: код в обоих режимах, кроме уже вошедшего. */
export const afterSignUp = (signedIn: boolean): 'code' | 'workspace' => (signedIn ? 'workspace' : 'code')
